import { Link, useNavigate } from "react-router-dom";

export default function VehicleIncidentTable() {
  const navigate = useNavigate();

  const handleNavigate = (vehiclecode) => {
    navigate(`/${vehiclecode}`);
  };

  const data = [
    { id: 1, vehiclecode: "Test Vehicle", driver: "Super Fast", location: "Pune", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 2, vehiclecode: "Test Vehicle", driver: "Super Fast", location: "Pune", description: "Trip", expense: "$2344", date: "Mon Jul 8 2023" },
    { id: 3, vehiclecode: "Test Vehicle", driver: "Super Fast", location: "Pune", description: "Trip", expense: "$1233", date: "Mon Jul 8 2023" },
    { id: 4, vehiclecode: "MH04KL0921", driver: "Super Fast", location: "Nashik", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 5, vehiclecode: "MH05MH5932", driver: "Super Fast", location: "Jalna", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 6, vehiclecode: "MH06MJ4321", driver: "Super Fast", location: "Pune", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 7, vehiclecode: "Test Vehicle", driver: "Super Fast", location: "Delhi", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 8, vehiclecode: "MH08KK4909", driver: "Super Fast", location: "Goa", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
    { id: 9, vehiclecode: "MH11KL0008", driver: "Super Fast", location: "Mumbai", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
    { id: 10, vehiclecode: "MH20UI3424", driver: "Super Fast", location: "Mumbai", description: "trip", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 11, vehiclecode: "Test Vehicle", driver: "Test Driver", location: "Mumbai", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
    { id: 12, vehiclecode: "MH23MK8245", driver: "Test Driver", location: "Mumbai", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 13, vehiclecode: "MH24NF5321", driver: "Jake Sprrow", location: "Mumbai", description: "Drop", expense: "$2000", date: "Tue Jul 9 2023" },
    { id: 14, vehiclecode: "MH22PQ4441", driver: "Tom", location: "Assam", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 15, vehiclecode: "New Vehicle", driver: "John wick", location: "North", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 16, vehiclecode: "MH11FG9090", driver: "John wick", location: "South", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
    { id: 17, vehiclecode: "MH20UI1221", driver: "Tom", location: "West", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 18, vehiclecode: "New Vehicle", driver: "John", location: "East", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
    { id: 19, vehiclecode: "MH20SQ0987", driver: "Harry", location: "North", description: "drop", expense: "$2000", date: "Mon Jul 8 2023" },
    { id: 20, vehiclecode: "New Vehicle", driver: "Jerrey", location: "Mumbai", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
  ];

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Incident</h4>
        <div className="yc-header-actions">
          <Link to="/accountant/createvehicleincident" className="btn btn-primary">
            Create Vehicle Incident
          </Link>
          <div className="dropdown">
            <button
              id="btnGroupDropExport"
              type="button"
              className="btn btn-primary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
              <li><a className="dropdown-item" href="#">Save as PDF</a></li>
              <li><a className="dropdown-item" href="#">Save as CSV</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select className="form-select">
            <option>All</option>
            <option>MH20EE3948</option>
            <option>Test Vehicle</option>
          </select>
          <input type="text" className="form-control" placeholder="Location" />
          <button type="button" className="btn btn-primary">Clear</button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-8">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Vehicle Number/Name</div>
            <div className="yc-list-cell">Driver</div>
            <div className="yc-list-cell">Location</div>
            <div className="yc-list-cell">Description</div>
            <div className="yc-list-cell">Expense</div>
            <div className="yc-list-cell">Date</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {data.map((row, idx) => (
            <div key={row.id} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-8">
                <div className="yc-list-cell">{idx + 1}</div>
                <div className="yc-list-cell">{row.vehiclecode}</div>
                <div className="yc-list-cell">{row.driver}</div>
                <div className="yc-list-cell">{row.location}</div>
                <div className="yc-list-cell">{row.description}</div>
                <div className="yc-list-cell">{row.expense}</div>
                <div className="yc-list-cell">{row.date}</div>
                <div className="yc-list-cell yc-list-cell--actions">
                  <button
                    type="button"
                    className="yc-action-icon"
                    onClick={() => handleNavigate(row.vehiclecode)}
                    title="View"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <Link
                    to="/accountant/updatevehicleincident"
                    className="yc-action-icon"
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Link>
                  <button
                    type="button"
                    className="yc-action-icon yc-action-icon--danger"
                    onClick={() => handleNavigate(row.vehiclecode)}
                    title="Delete"
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
